import { ActivityLogType } from '@app/models/log/activity';

export const getActivityLogTranslation = (value: ActivityLogType) => {
  return value
    .split('_')
    .map(
      (word: string) =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(' ');
};

export const isActivityLogSuccessful = (type: ActivityLogType): boolean => {
  const failedTypes: ActivityLogType[] = [
    'INTEGRATION_FAILED' as ActivityLogType,
    'MESSAGE_FAILED' as ActivityLogType,
  ];
  return !failedTypes.includes(type);
};

export const getActivityLogStatusColor = (type: ActivityLogType): string => {
  return isActivityLogSuccessful(type)
    ? 'bg-green-100 text-green-800'
    : 'bg-red-100 text-red-800';
};
